import Scroll from '../mixins/Scroll'

export default class SlimCarousel {
    constructor(params) {
        this.params = params
        const carousel = params.el ?? params.carousel

        this.el = {
            carousel: carousel instanceof Element ? carousel : document.getElementById(carousel),
            arrowRight: 'js-slime-carousel-right',
            arrowLeft: 'js-slime-carousel-left',
            scroll: 'js-slim-carousel-scroll-container',
            item: 'slim-carousel__item',
            point: 'js-slime-carousel-point',
        }

        try {
            this.initEvents()
        } catch {}
    }

    /**
     * @inheritDoc Init events
     */
    initEvents() {
        const { carousel, scroll, item } = this.el
        let { arrowLeft, arrowRight, point } = this.el
        const scrollContainer = carousel.getElementsByClassName(scroll)[0]
        const slideItem = carousel.getElementsByClassName(item)[0].offsetWidth / 2 || 0
        const getWidth = this.getCarouselWidth(carousel)
        arrowLeft = carousel.getElementsByClassName(arrowLeft)[0]
        arrowRight = carousel.getElementsByClassName(arrowRight)[0]
        point = [...carousel.getElementsByClassName(point)]
        const itemCarousel = [...carousel.getElementsByClassName(item)]
        const carouselActualWidth = this.getCarouselMaxWidth(carousel)
        let scrollTimeout = null
        let animateTimeout = null

        if (carousel.classList.contains('js-scroll-only-section')) {
            for (let i = 1; i < itemCarousel.length; i++) {
                animateTimeout = setTimeout(() => {
                    this.showCarouselElementById(i)
                    scrollContainer.scrollTo(getWidth * i, 0)
                }, 5500 * (i + 1))
            }
        }

        if (carouselActualWidth >= getWidth && ((arrowRight && arrowLeft) || point)) {
            point.forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault()

                    clearTimeout(animateTimeout)
                    const pointIndex = e.target.getAttribute('data-id')
                    this.showCarouselElementById(pointIndex)
                })
            })

            scrollContainer.addEventListener('scroll', (e) => {
                const position = e.target.scrollLeft
                if (arrowLeft && arrowRight) {
                    this.arrowResolver(position, arrowLeft, arrowRight, carouselActualWidth, getWidth)
                }

                if (carousel.classList.contains('js-scroll-only-section')) {
                    const scrollToElement = Math.round(position / getWidth) * getWidth
                    clearTimeout(scrollTimeout)
                    scrollTimeout = setTimeout(function () {
                        e.target.scrollTo(scrollToElement, 0)
                    }, 500)
                }
            })

            arrowRight.addEventListener('click', (e) => {
                e.preventDefault()
                Scroll.scrollTo(undefined, true, {
                    left: scrollContainer.scrollLeft + (getWidth - slideItem - 30),
                    element: scrollContainer,
                })
            })

            arrowLeft.addEventListener('click', (e) => {
                e.preventDefault()
                Scroll.scrollTo(undefined, true, {
                    left: scrollContainer.scrollLeft - (getWidth - slideItem - 30),
                    element: scrollContainer,
                })
            })

            this.arrowResolver(0, arrowLeft, arrowRight, carouselActualWidth, getWidth)
        } else {
            /** Hide arrow **/
            arrowRight.classList.add('d-none')
            arrowLeft.classList.add('d-none')
        }
    }

    /**
     * @
     * @param position
     * @param arrowLeft
     * @param arrowRight
     * @param carouselActualWidth
     * @param getWidth
     */
    arrowResolver(position = 0, arrowLeft, arrowRight, carouselActualWidth, getWidth) {
        if (position === 0) {
            arrowLeft.classList.add('d-none')
            arrowRight.classList.remove('d-none')
        } else if (Math.ceil(position) >= carouselActualWidth - getWidth) {
            // Disable right arrow
            arrowLeft.classList.remove('d-none')
            arrowRight.classList.add('d-none')
        } else {
            arrowLeft.classList.remove('d-none')
            arrowRight.classList.remove('d-none')
        }
    }

    /**
     * @inheritDoc]Get Carousel width
     * @param carousel
     * @return {number}
     */
    getCarouselWidth(carousel) {
        return carousel.getElementsByClassName(this.el.scroll)[0].offsetWidth
    }

    /**
     * @inheritDoc Get carousel max real width
     * @param carousel
     * @return {number}
     */
    getCarouselMaxWidth(carousel) {
        return carousel.getElementsByClassName(this.el.scroll)[0].scrollWidth
    }

    showCarouselElementById(id) {
        const { carousel, item } = this.el
        let { point } = this.el
        point = [...carousel.getElementsByClassName(point)]
        const itemCarousel = [...carousel.getElementsByClassName(item)]

        point.forEach((item) => {
            item.classList.remove('point--active')
        })
        point[id].classList.add('point--active')

        itemCarousel.forEach((item) => {
            item.classList.remove('banner--active')
        })
        itemCarousel[id].classList.add('banner--active')
    }
}
